import { numberWithCommas } from '@common/utils';

export const ceilTens = (num: number) => {
  return Math.ceil(num / 10) * 10;
};

export const bpToDecimal = (bp: number) => {
  return bp / 10000;
};

export const asCurrency = (n: number) => `${numberWithCommas(n)}원`;

export const limitToMax = (value: number, max_value: number | null) => {
  if (!max_value) {
    return value;
  }
  return value > max_value ? max_value : value;
};

export const getNonNegativeValue = (value: number, default_value: number) => {
  const is_zero_or_negative = value <= 0;
  return is_zero_or_negative ? default_value : value;
};
